import { RouteRecordRaw } from 'vue-router';

import { settingsLayoutComponents } from '~/_v3/common/ui/components/layout';
import { RouteKeys } from '~/router/routes.domain';

import { DematRoute } from './demat/demat.routes';
import { ExportRoute } from './export/export.routes';
import { FranceConnectRoute } from './franceConnect/franceConnect.routes';
import { MergeRoute } from './merge/merge.routes';
import { ProfileRoute } from './profile/profile.routes';
import { SafetyRoute } from './safety/safety.routes';

export const AccountRoute: RouteRecordRaw = {
	name: RouteKeys.ACCOUNT,
	path: '/account',
	components: {
		default: () => import('./account.vue'),
		...settingsLayoutComponents
	},
	children: [ProfileRoute, SafetyRoute, FranceConnectRoute, DematRoute, MergeRoute, ExportRoute]
};
